import { ArrowRightIcon, ExternalLinkIcon } from '@rsos/assets/icons';
import { Box } from '@rsos/base-components';
import {
  ExternalLinkContent,
  ExternalLinkTitle,
  ExternalLinkSubtitle,
  ArrowRightBox,
} from './ExternalLinkCard.styles';

/**
 * Nested component for displaying the card content in ExternalLinkCard.js.
 * @param {String} title - Card title
 * @param {String} subtitle - Card subtitle
 */
const ExternalLinkCardContent = ({ title = '', subtitle = '' }) => (
  <ExternalLinkContent data-name="external-link-content">
    <Box flow={4}>
      <Box align="center" flow={4} horizontal>
        <ExternalLinkIcon color="primaryText" height={12} width={12} />
        <ExternalLinkTitle data-name="external-link-title">
          {title}
        </ExternalLinkTitle>
      </Box>
      <ExternalLinkSubtitle data-name="external-link-subtitle">
        {subtitle}
      </ExternalLinkSubtitle>
    </Box>
    <ArrowRightBox>
      <ArrowRightIcon color="secondaryText" height="20px" width="22px" />
    </ArrowRightBox>
  </ExternalLinkContent>
);

export default ExternalLinkCardContent;
